import { IRootState } from "../../app/types/rootReducers.t";
import { createSelector } from "reselect";
import { INotificationMessageIncoming, TNotificationMessageTypes } from "./notifications.t";

const moduleSelector = (state: IRootState) => state.notifications;

export const getNotificationsWsSendMessageFn = createSelector(
    moduleSelector, state => state.wsSendMessageFn,
);

export const getNotificationsMessages = createSelector(
    moduleSelector, state => state.messages,
);

type IGetNotificationsLastMessageByTypeReturn =
    (state: IRootState, props: TNotificationMessageTypes) => INotificationMessageIncoming['params'];

export const getNotificationsLastMessageByType: IGetNotificationsLastMessageByTypeReturn = createSelector(
    [getNotificationsMessages, (state, type) => type],
    (messages, type) => messages[type],
);

export const getShowedMessage = createSelector(
    moduleSelector, state => state.showedMessage,
);

export const getShowMessagesQueueLength = createSelector(
    moduleSelector, state => state.showMessagesQueue.length,
);

export const getNotificationToast = createSelector(
    moduleSelector, state => state.toast,
);

export const getNotificationShowedToasts = createSelector(
    moduleSelector, state => state.showedToasts,
);

export const getIsShowAccountEventIndicator = createSelector(
    moduleSelector, state => state.isShowAccountEventIndicator,
);

export const getNotificationsWebsocketInstanceSelector = createSelector(
    moduleSelector, state => state.websocketInstance,
);
